import { Component, Input } from '@angular/core';
import { TogglService } from '../toggl.service';
import { LoginService } from '@intranet/modules/login';

@Component({
    selector: 'toggl-login',
    templateUrl: './toggl-login.component.html',
    styleUrls: ['./toggl-login.component.scss']
})
export class TogglLoginComponent {
    @Input() hideLogout: boolean = false;

    togglUser: string;
    togglPassword: string;
    loginFailed: boolean = false;
    errorText: string | null = null;

    constructor(private togglService: TogglService, public loginService: LoginService) { }

    get isLoggedIn(): boolean {
        return this.togglService.isLoggedIn();
    }
    isToggleConnected() {
        return this.togglService.isLoggedIn();
    }

    onTogglSubmit() {
      this.errorText = null; // reset
      this.togglService.login(this.togglUser, this.togglPassword).subscribe(r => {
        this.loginFailed = !r.result;

        // Show message if Toggl is disabled
        if (!r.result && r.message === 'Toggl is disabled') {
          this.loginFailed = false; // hide the "wrong password" banner
          this.errorText = 'Toggl is temporarily disabled in the Intranet.';
        }
      });
    }

    disconnectToggl() {
        this.togglService.logout();
    }
}